<script setup>
import { computed } from 'vue'
import countriesData from '@/assets/countries.json'

const props = defineProps(['country'])

const flagData = computed(() => {
  if (!props.country) return null
  const countryObj = countriesData.find(c => c.isoAlpha2 === props.country.toUpperCase())
  return countryObj
})

const flagStyle = computed(() => {
  if (!flagData.value) return {}
  return {
    backgroundImage: `url(data:image/png;base64,${flagData.value.flag})`,
  }
})
</script>

<template>
  <span 
    :style="flagStyle"
    class="flag"
    :title="flagData?.name"
  ></span>
</template>

<style scoped>
  .flag {
    display: inline-block;
    width: 20px;
    height: 15px;
    vertical-align: middle;
    background-size: cover;
    background-position: center;
    border-radius: 2px;
  }
</style>